<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gbD3on/tc-custom/9781595554499.jpg?1708485715588" alt="This image is the cover for the book Citizen Newt"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Citizen Newt
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The definitive, authorized biography of one of the most important, provocative, and visionary political figures of our time.</b></p><p>In one way or another Newt Gingrich has been leading a revolution for most of his life. <i>Citizen Newt </i>is<i> </i>the definitive account of that struggle. Writing with the full cooperation of Speaker Gingrich and the players around him, <i>New York Times</i> bestselling author Craig Shirley captures the events, ideas, failures, and successes of Newton Leroy Gingrich—one of the most complex, influential, and durable political figures of our time.</p><p>Returning to Gingrich’s childhood in Pennsylvania and his formative years as a young history professor, <i>Citizen Newt</i> moves through Gingrich’s first forays into politics and takes readers behind the scenes of the Congressman’s crucial role in the Reagan Revolution, his battles with George H. W. Bush and Bill Clinton, and his masterly orchestration of 1994s “Gingrich Revolution” and the Contract with America, which catapulted him to national prominence and forever changed congressional and national politics.</p><p>Drawing upon untold stories from Gingrich and those who know him best—political allies and opponents, Washington insiders and political iconoclasts, Capitol Hill staffers and colleagues—Shirley has crafted a fascinating, humorous, humanizing, and insightful account of a true American original.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Craig Shirley
      </h2>
      
      <p class="authorDescription body article"><P>Craig Shirley is the author of four critically praised bestsellers about Ronald Reagan, <I>Reagan's Revolution</I>, <I>Rendezvous with Destiny,</I><I><I>Last Act, and Reagan Rising</I></I>. His book <I>December 1941</I> appeared multiple times on the <I>New York Times</I> bestseller list. Shirley is chairman of Shirley &amp; Banister Public Affairs and is a widely sought-after speaker and commentator. The Visiting Reagan Scholar at Eureka College, Shirley is on the Board of Governors of the Reagan Ranch and lectures frequently at the Reagan Library, and he has written extensively for Newsmax, <I>The</I><I>Washington Post</I>, the <I>Washington Examiner</I>, the <I>Washington Times</I>, the <I>Los Angeles Times</I>, <I>Townhall</I>, <I>Breitbart</I>, <I>National Review</I>, <I>LifeZette</I>, <I>CNS</I>, and many other publications. Considered one of the foremost public intellectuals on the history of conservatism in America, Shirley also wrote <I>Mary Ball Washington: The Untold Story of George Washington's Mother</I>, which won the "People's Choice Award" from the Library of Virginia. He is now working on <I>The Search for Reagan</I> and an examination of the Donald Trump presidency titled <I>American Prometheus</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollinsChristianPublishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0fae39a8